import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faSearch } from "@fortawesome/free-solid-svg-icons";
import buymoduleService from "../../services/BuyModule-service/buy-module-service";
import { Skeleton } from "primereact/skeleton";
export default function PropertyFilter({
  filters,
  OnRangeChange,
  OnInputChange,
  buttonClick,
  ClearAllfilter,
  clearSelectedFilter,
}) {
  const [search, setSearch] = useState("");
  const [openLocation, setOpenLocation] = useState(false);
  const [location, setLocation] = useState([]);
  const [locationError, setLocationError] = useState("");
  const [loading, setLoading] = useState(false);
  const locationdropdown = useRef(null);
  const [searchedfor, setSearchedFor] = useState("");
   const [propertyType, setPropertyType]=useState([])
  const [propertyError, setPropertyError]=useState("")
  const[allbhk , setallbhk]=useState([]);
  const[allBhkError, setallbhkError]=useState("")
  const[propertyTypeLoading, setpropertyTypeLoading]=useState(false);
  const[allbhkLoading,setAllbhkLoading]=useState(false);
  const handleClickOutside = (event) => {
    if (
      locationdropdown.current &&
      !locationdropdown.current.contains(event.target)
    ) {
      setOpenLocation(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // useEffect to fetch location suggestions based on search input
  // useEffect(() => {
  //   setLoading(true);
  //   const fetchAllLocations = async () => {
  //      setLocationError("");
  //     try {
  //       const response = await buymoduleService.allLocations();
  //       setLocation(response.data?.result || []);
  //     } catch (err) {
  //       setLocationError("No Locations Found");
  //       setLocation([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //    if (searchedfor !== "") {
  //     fetchLocationSuggestions(searchedfor);
  //   }
  //   else{
  //     fetchAllLocations();
  //   }

  // }, [searchedfor]);
//this is for to fetch location.
  useEffect(() => {
  const timer = setTimeout(() => {
    setLoading(true);
    const fetchAllLocations = async () => {
      try {
        const response = await buymoduleService.allLocations();
        setLocation(response.data?.result || []);
      } catch (err) {
        setLocationError("No Locations Found");
      } finally {
        setLoading(false);
      }
    };

    if (searchedfor !== "") {
      fetchLocationSuggestions(searchedfor);
    } else {
      fetchAllLocations();
    }
  }, 300); 

  return () => clearTimeout(timer); 
}, [searchedfor]);


//this is used to fetch the property location and bhk types from database
useEffect(()=>{
  const fetchPropertyTypeandBhk=async()=>
    {
      setpropertyTypeLoading(true)
      setAllbhkLoading(true)
      try {
        const[ propertyTypeResponse, bhkresponse ]=
        await Promise.all([buymoduleService.allPropertyType(),buymoduleService.allbhk()]) 
        setPropertyType(propertyTypeResponse.data?.result||[])
        setallbhk(bhkresponse.data?.result||[]);
      } catch (error) {
        setPropertyError("Failed to load property types");
         setallbhkError("Failed to load BHK types")
      }
      finally
      {
        setpropertyTypeLoading(false)
        setAllbhkLoading(false)
      }
    }
   
    fetchPropertyTypeandBhk();
   
},[])



  const handleInputChange = (e) => {
    OnInputChange(e);
  };
     const formatPrice = (value) => {
        if (value >= 10000000) {
          return (value / 10000000).toFixed(1).replace(".0", "") + " Cr";
        } else if (value >= 100000) {
          return (value / 100000).toFixed(1).replace(".0", "") + " Lakh";
        }
        return value;
      };
  const handleRangeChange = (name, value) => {
    if (name === "priceMax") {
      const formattedValue = formatPrice(value);
      OnRangeChange("filterPricemax", formattedValue);
    }

    OnRangeChange(name, value);

    // console.log("Range changed:", name, value);
  };
  const handleButtonClick = (name, value) => {
    buttonClick(name, value);
  };

  const onSearchClick = () => {
    buttonClick("search", search);
  
  };

  const clearAllFilter = () => {
    ClearAllfilter();
    setSearch("");
    setSearchedFor("");
  };

  const clearSelectedfilters = (name, value) => {
    clearSelectedFilter(name, value);
    if (name === "search") {
      setSearch("");
      setSearchedFor("");
    }
    if (name === "filterPricemax") {
      // clearSelectedFilter("priceMin", 0);
      clearSelectedFilter("priceMax", 0);
    }
  };

  const isAnyFilterActive = () => {
    if (!filters || typeof filters !== "object") return false;

    return Object.values(filters).some(
      (value) => value !== "" && value !== null && value !== 0
    );
  };

  const filterArray = Object.entries(filters).map(([key, value]) => ({
    key,
    value,
  }));

  const setSearched = (locationName) => {
  
    setSearch(locationName);
  setSearchedFor(locationName);
  buttonClick("search", locationName);
  setOpenLocation(false);
  };
  const fetchLocationSuggestions = async (searchedfor) => {
    setLoading(true);
    setLocationError("");
    try {
      const response = await buymoduleService.searchlocationSuggestions(
        searchedfor
      );
      setLocation(response.data?.result || []);
    } catch (error) {
      setLocationError("No Locations Found");
      setLocation([]);
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="buy-property-container">
      {/* Main Filters Section */}
      {isAnyFilterActive() && (
        <div className="clear-all-button d-flex justify-content-between filter-clear-section">
          <ul className="Applied-filters d-flex flex-wrap">
            {filterArray
              .filter((item) => item.value && item.key !== "priceMax")
              .map((item) => (
                <li key={item.key}>
                  {item.value === "H2L"
                    ? "High To Low"
                    : item.value === "L2H"
                    ? "Low To High"
                    : item.key === "filterPricemax"
                    ? `${item.value} Max Price`
                    : item.key === "priceMin"
                    ? `${item.value} Price`
                    : item.key === "areaMax"
                    ? `${item.value} max Sqft`
                    : item.key === "floor"
                    ? `${item.value} Floor`
                    : item.value}
                  <span>
                    <FontAwesomeIcon
                      icon={faClose}
                      className="clear-filter-btn"
                      onClick={() => clearSelectedfilters(item.key, item.value)}
                    />
                  </span>
                </li>
              ))}
          </ul>
          <div>
            <button
              className="clear-all-filters btn btn-primary  "
              onClick={clearAllFilter}
            >
              clear All
            </button>
          </div>
        </div>
      )}
      <div className="buy-property-section">
        {/* Search */}
        <div className="buy-property-filter-group">
          <label className="buy-property-label">Search</label>
          <div className="buy-property-search-input-wrapper">
            <input
              type="text"
              name="search"
              placeholder="Search by Location, Building"
              value={ search}
              autoComplete="off"
              onChange={(e) => {
                const value = e.target.value;
                setSearch(value);
                setSearchedFor(value);
    // buttonClick("search", value);
              }}
               onKeyDown={(e) => {
    // Optional: Allow Enter key to search
    if (e.key === 'Enter') {
      onSearchClick();
    }
  }}
              onClick={() => setOpenLocation(true)}
              className="buy-property-search-input"
            />
            <div className="search-button-icon" onClick={onSearchClick}>
              <FontAwesomeIcon
                icon={faSearch}
                className=" text-pink "
                size="sm"
              />
            </div>
          </div>
          {openLocation && (
            <div className="buy-location-suggestion-box" ref={locationdropdown}>
              <ul className="buy-location-suggestion-list d-flex gap-2 flex-wrap">
                {loading ? (
                  <p>Loading..</p>
                ) : locationError ? (
                  <p>{locationError}</p>
                ) : location.length > 0 ? (
                  location.map((loc, index) => (
                    <li
                      key={index}
                      className="location-suggestion-item"
                      onClick={() => setSearched(loc.locationName)}
                    >
                      {loc.locationName}
                    </li>
                  ))
                ) : (
                  <p>No Locations Found</p>
                )}
              </ul>
            </div>
          )}
        </div>

        {/* type */}
        <div className="buy-property-filter-group">
          <label className="buy-property-label">Type</label>
          <div className="buy-property-radio-group">
            <label className="buy-property-radio-label">
              <input
                type="radio"
                name="type"
                value="Residential"
                checked={filters.type === "Residential"}
                onChange={handleInputChange}
                className="buy-property-radio-input"
              />
              <span>Residential</span>
            </label>
            <label className="buy-property-radio-label">
              <input
                type="radio"
                name="type"
                value="Commercial"
                checked={filters.type === "Commercial"}
                onChange={handleInputChange}
                className="buy-property-radio-input"
              />
              <span>Commercial</span>
            </label>
             <label className="buy-property-radio-label">
              <input
                type="radio"
                name="type"
                value="Mixed Usage"
                checked={filters.type === "Mixed Usage"}
                onChange={handleInputChange}
                className="buy-property-radio-input"
              />
              <span>Mixed Usage</span>
            </label>
          </div>
        </div>
         {/* Property type */}
        <div className="buy-property-filter-group">
          <label className="buy-property-label">Property Type</label>
          <div className="buy-property-radio-group">
           {propertyTypeLoading ?
           (
          <>
          <Skeleton width="5rem" className="mb-2" borderRadius="16px" ></Skeleton>
          <Skeleton width="9rem" className="mb-2" borderRadius="16px" ></Skeleton>
          <Skeleton width="13rem" className="mb-2" borderRadius="16px" ></Skeleton>
          <Skeleton width="16rem" className="mb-2" borderRadius="16px" ></Skeleton>
          
          </>
           ):(
            propertyType.map((type) => (
              <label key={type} className="buy-property-radio-label">
                <input
                  type="radio"
                  name="propertyType"
                  value={type.propertyType}
                  checked={filters.propertyType === type.propertyType}
                  onChange={handleInputChange}
                  className="buy-property-radio-input"
                />
                <span>
                  {/* {type === "apartment" && "Apartment"}
                  {type === "standalone" && "Standalone Builder"}
                  {type === "gated" && "Gated Community"}
                  {type === "independent" && "Independent House/Villa"}
                  {type=="plot/land"&& "Plots/Lands"} */}
                  {type.propertyType}
                </span>
              </label>
            ))
          )}
          </div>
        </div>

        {/* BHK */}
        <div className="buy-property-filter-group">
          <label className="buy-property-label">BHK</label>
          <div className="buy-property-button-group">
            {allbhkLoading ? (
              <>
              <Skeleton width="4rem" height="2rem" borderRadius="16px"></Skeleton>
              <Skeleton width="4rem" height="2rem" borderRadius="16px"></Skeleton>
              <Skeleton width="4rem" height="2rem" borderRadius="16px"></Skeleton>
              </>
            ):(
            allbhk.map((bhk) => (
              <button
                key={bhk.bhkType}
                onClick={() => handleButtonClick("bhk", bhk.bhkType)}
                className={`buy-property-button ${
                  filters.bhk === bhk.bhkType
                    ? "buy-property-button-active"
                    : ""
                }`}
              >
                {bhk.bhkType}
              </button>
            ))
            )}
          </div>
        </div>

        {/* Price range */}
        <div className="buy-property-filter-group">
          <label className="buy-property-label">Price Range</label>
          <div className="buy-property-range-container">
            <input
              type="range"
              name="priceMax"
              min="1000000"
              max="50000000"
              value={filters.priceMax}
              onChange={(e) =>
                handleRangeChange("priceMax", Number.parseInt(e.target.value))
              }
              className="buy-property-range-slider"
            />
            <div className="buy-property-range-labels">
              <span>&#8377; 10L</span>
              <span>{filters.priceMax!==0?`Max-Price:${formatPrice(filters.priceMax)}`:null}</span>
              <span>&#8377; 5Cr+</span>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Filters Section */}
      <div className="buy-property-section">
        <h2 className="buy-property-section-title">Additional Filters</h2>

        {/* Status */}
        <div className="buy-property-filter-group">
          <label className="buy-property-label">Status</label>
          <div className="buy-property-radio-group">
            <label className="buy-property-radio-label">
              <input
                type="radio"
                name="status"
                value="Ready To Move"
                checked={filters.status === "Ready To Move"}
                onChange={handleInputChange}
                className="buy-property-radio-input"
              />
              <span>Ready to move in</span>
            </label>
            <label className="buy-property-radio-label">
              <input
                type="radio"
                name="status"
                value="Under Construction"
                checked={filters.status === "Under Construction"}
                onChange={handleInputChange}
                className="buy-property-radio-input"
              />
              <span>Under Construction</span>
            </label>
          </div>
        </div>

        {/* Listing type */}
        <div className="buy-property-filter-group">
          <label className="buy-property-label">Listing Type</label>
          <div className="buy-property-radio-group">
            <label className="buy-property-radio-label">
              <input
                type="radio"
                name="listingType"
                value="new"
                checked={filters.listingType === "new"}
                onChange={handleInputChange}
                className="buy-property-radio-input"
              />
              <span>New</span>
            </label>
            <label className="buy-property-radio-label">
              <input
                type="radio"
                name="listingType"
                value="resale"
                checked={filters.listingType === "resale"}
                onChange={handleInputChange}
                className="buy-property-radio-input"
              />
              <span>Resale</span>
            </label>
          </div>
        </div>

        {/* Seller */}
        <div className="buy-property-filter-group">
          <label className="buy-property-label">Seller</label>
          <div className="buy-property-radio-group">
            <label className="buy-property-radio-label">
              <input
                type="radio"
                name="seller"
                value="individual"
                checked={filters.seller === "individual"}
                onChange={handleInputChange}
                className="buy-property-radio-input"
              />
              <span>Individual</span>
            </label>
            <label className="buy-property-radio-label">
              <input
                type="radio"
                name="seller"
                value="builder"
                checked={filters.seller === "builder"}
                onChange={handleInputChange}
                className="buy-property-radio-input"
              />
              <span>Builder</span>
            </label>
          </div>
        </div>

       

        {/* Age */}
        <div className="buy-property-filter-group">
          <label className="buy-property-label">Age</label>
          <div className="buy-property-button-group">
            {["0-1", "1-5", "5-10", "10+"].map((ageRange) => (
              <button
                key={ageRange}
                onClick={() => handleButtonClick("age", ageRange + " Years")}
                className={`buy-property-button ${
                  filters.age === ageRange + " Years"
                    ? "buy-property-button-active"
                    : ""
                }`}
              >
                {ageRange} Years
              </button>
            ))}
          </div>
        </div>

        {/* floor */}
        <div className="buy-property-filter-group">
          <label className="buy-property-label">Floor</label>
          <div className="buy-property-button-group">
            {["1-3", "4-7", "8-12", "12+"].map((floor) => (
              <button
                key={floor}
                onClick={() => handleButtonClick("floor", floor)}
                className={`buy-property-button ${
                  filters.floor === floor ? "buy-property-button-active" : ""
                }`}
              >
                {floor}
              </button>
            ))}
          </div>
        </div>

        {/* Area sqft */}
        <div className="buy-property-filter-group">
          <label className="buy-property-label">Area in Sq. ft.</label>
          <div className="buy-property-range-container">
            <input
              type="range"
              name="areaMax"
              min="500"
              max="5000"
              value={filters.areaMax}
              onChange={(e) =>
                handleRangeChange("areaMax", Number.parseInt(e.target.value))
              }
              className="buy-property-range-slider"
            />
            <div className="buy-property-range-labels">
              <span>500</span>
              <span>{filters.areaMax!==0?`Max-Area:${filters.areaMax} Sqft`:null}</span>
              <span>5000+</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
